// MicrosoftCallback.js
import { useEffect } from "react";
import { msalInstance } from "../../config/MsalConfig";

export default function MicrosoftCallback() {
    useEffect(() => {
        msalInstance.handleRedirectPromise().then((response) => {
            if (response) {
                const idToken = response.idToken;
                console.log("ID Token:", idToken);
                // Django API ko bhejo
            }
        });
    }, []);

    return <div>Processing Microsoft login...</div>;
}
